<template>
    <div class="legal-person">
        <menuBox :step="3"></menuBox>
        <div class="legal-box">
            <div class="img-box">
                <p>Soxiao</p>
                <img src="../assets/img-5.png" alt="">
            </div>
            <div class="text">
                <ul>
                    <li>
                        Master of Engineering, Department of Electronic and Information Engineering, Huazhong University of Science and Technology
                    </li>
                    <li>
                        Bachelor of Engineering, Department of Electronic and Information Engineering, Huazhong University of Science and Technology
                    </li>
                    <li>
                        Able to use Axure to design product interaction proficiently
                    </li>
                    <li>
                        Familiar with the interaction specifications and design principles of the mobile terminal
                    </li>
                    <li>
                        Be proficient in using Microsoft Visio and other office tools, and be good at using graphics to express business logic and design ideas.
                    </li>
                    <li>
                        Passed the System Analyst Examination for Computer Technology and Software Professional Technical Qualification (Level) in 2011.
                    </li>
                    <li>
                        Four years of C language development experience, with more than two years of large-scale programming, coding and debugging experience, and a good sense of code specification.
                    </li>
                    <li>
                        Familiar with TCP/IP protocol, as well as application layer network protocols such as CAPWAP and WAPI.
                    </li>

                </ul>
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.legal-person {
    .legal-box {
        margin-top: 182px;
        display: flex;
        padding: 0px 270px 160px 270px;
        align-items: center;
        .img-box {
            p {
                font-size: 64px;
                font-weight: 500;
                color: #333333;
                text-align: center;
            }

            img {
                width: 270px;
                height: 350px;
                margin-top: 60px;
            }
        }
        .text{
            font-size: 18px;
            font-weight: 400;
            color: #999999;
            margin-left: 58px;
            li{
                list-style-type:disc;
                margin-top: 20px;
            }
        }
    }
}
</style>